export const undertakeColumns = [
  {
    label: '结算项目',
    value: 'settleName',
    width: '200px',
    align: 'center'
  },
  {
    label: '结算总费用（元）',
    value: 'operationalYuanAmount',
    width: '150px',
    align: 'center'
  },
  {
    label: '确认状态',
    value: 'status',
    width: '150px',
    align: 'center'
  },
  {
    label: '确认收款时间',
    value: 'confirmPaidTime',
    width: '150px',
    align: 'center'
  },
  {
    label: '操作',
    value: 'action',
    width: '120px',
    align: 'center'
  }
]

export const undertakeDetailColumns = [
  {
    label: '项目类型',
    value: 'projectCategory',
    width: '120px',
    align: 'center'
  },
  {
    label: '项目名称',
    value: 'projectName',
    width: '160px',
    align: 'center'
  },
  {
    label: '调查任务',
    value: 'taskName',
    width: '180px',
    align: 'center'
  },
  {
    label: '执行时间',
    value: 'investigateTime',
    width: '130px',
    align: 'center'
  },
  {
    label: '结算方式',
    value: 'settleMode',
    width: '120px',
    align: 'center'
  },
  {
    label: '未结算数量',
    value: 'unitQuantity',
    width: '120px',
    align: 'center'
  },
  {
    label: '单价(元)',
    value: 'unitPriceYuan',
    width: '150px',
    align: 'center'
  },
  {
    label: '结算总费用(元)',
    value: 'operationalYuanAmount',
    width: '150px',
    align: 'center'
  },
  {
    label: '操作',
    value: 'action',
    width: '100px',
    align: 'center'
  }
]

export const csCode = {
  NOLAUNCH: 0,
  CONFIRMING: 1,
  ALREADYCONFIRM: 2,
  ALREADYREJECT: 3,
  ALREADYCANCEL: 4,
  ALREADYPAID: 5,
  WAITPAY: 6,
  WAITPAID: 7
}

export const confirmStatusMap = {
  [csCode.NOLAUNCH]: '未发起',
  [csCode.CONFIRMING]: '待确认结算单',
  [csCode.ALREADYCONFIRM]: '已确认',
  [csCode.ALREADYREJECT]: '已拒绝',
  [csCode.ALREADYCANCEL]: '已撤销',
  [csCode.ALREADYPAID]: '已确认收款',
  [csCode.WAITPAY]: '待打款',
  [csCode.WAITPAID]: '待确认收款'
}

export const pjCtyCode = {
  QUESTION: 0,
  INVEST: 1,
  IMPORT: 2
}

export const projectCategoryMap = {
  [pjCtyCode.QUESTION]: '问卷调查',
  [pjCtyCode.INVEST]: '明察暗访',
  [pjCtyCode.IMPORT]: '人工导入'
}

export const settleModeCode = {
  TASK: 0,
  QUESTION: 1,
  DAY: 2,
  LADDER: 3,
  POINT: 4
}

export const settleModeMap = {
  [settleModeCode.TASK]: '按任务方式',
  [settleModeCode.QUESTION]: '按答卷数量',
  [settleModeCode.DAY]: '按天',
  [settleModeCode.LADDER]: '按阶梯计价',
  [settleModeCode.POINT]: '按点位'
}

export const undertakeStatusCode = {
  WAIT: 0,
  CONFIRMING: 1,
  APPROVED: 2,
  REJECT: 3,
  RESCINDED: 4,
  CONFIRM_PAID: 5
}
